import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import BackMethods from "../../back_component/BackMethods";

export default function ChangePasswordPage() {
  const { backEnd_request } = BackMethods();

  // =============================
  //  الحالة (State)
  // =============================
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =============================
  //  التحقق من صحة البيانات
  // =============================
  const validate = () => {
    const newErrors = {};
    if (!currentPassword.trim())
      newErrors.currentPassword = "الرجاء إدخال كلمة المرور الحالية";
    if (!newPassword.trim())
      newErrors.newPassword = "الرجاء إدخال كلمة المرور الجديدة";
    if (!confirmPassword.trim())
      newErrors.confirmPassword = "الرجاء تأكيد كلمة المرور الجديدة";
    if (newPassword && confirmPassword && newPassword !== confirmPassword)
      newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // =============================
  //  إرسال النموذج
  // =============================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setSuccessMessage("");

    if (!validate()) return;

    setIsSubmitting(true);
    try {
      const res = await backEnd_request.post("auth/changePassword", {
        currentPassword,
        newPassword,
      });
      console.log(res);
      setSuccessMessage("تم تغيير كلمة المرور بنجاح ✅");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.log(error.response.data);
      if ("Password must be at least 6 characters and contain letters and numbers" == error.response.data)
        setFormError("يجب ان تحوي كلمة المرور على الاقل 6 محارف مكونة من احرف وارقام");
    } finally {
      setIsSubmitting(false);
    }
  };

  // =============================
  //  وظائف إظهار/إخفاء الحقول
  // =============================
  const toggleCurrent = () => setShowCurrent(!showCurrent);
  const toggleNew = () => setShowNew(!showNew);
  const toggleConfirm = () => setShowConfirm(!showConfirm);

  // =============================
  //  واجهة المستخدم (UI)
  // =============================
  return (
    <div className="bg-dark">
      <div className="container py-5">
        <div className="py-5">
          <div className="row justify-content-center align-items-center">
            <div className="text-center mb-4">
              <h1
                className="text-light fw-bold"
                style={{ fontSize: "2.3rem", letterSpacing: "2px" }}
              >
                تغيير كلمة المرور
              </h1>
              <p className="text-light" style={{ fontSize: "1.1rem" }}>
                قم بإدخال كلمة المرور الحالية والجديدة لتحديثها
              </p>
            </div>

            <div className="row justify-content-center">
              <div className="card col-lg-5 col-sm-12 border-0 shadow-lg">
                <div className="card-header bg-light text-center p-4">
                  <h3 className="text-dark m-0">تحديث كلمة المرور</h3>
                </div>

                <div className="card-body bg-white p-5 rounded-bottom">
                  <form onSubmit={handleSubmit} noValidate>
                    {/* =======================
                        🔑 كلمة المرور الحالية
                    ======================= */}
                    <div className="mb-4 position-relative">
                      <input
                        type={showCurrent ? "text" : "password"}
                        className={`form-control p-4 ${errors.currentPassword ? "is-invalid" : ""
                          }`}
                        placeholder="كلمة المرور الحالية"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <span
                        onClick={toggleCurrent}
                        role="button"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      >
                        {showCurrent ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                      </span>
                      {errors.currentPassword && (
                        <div className="invalid-feedback text-end">
                          {errors.currentPassword}
                        </div>
                      )}
                    </div>

                    {/* =======================
                         كلمة المرور الجديدة
                    ======================= */}
                    <div className="mb-4 position-relative">
                      <input
                        type={showNew ? "text" : "password"}
                        className={`form-control p-4 ${errors.newPassword ? "is-invalid" : ""
                          }`}
                        placeholder="كلمة المرور الجديدة"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        onClick={toggleNew}
                        role="button"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      >
                        {showNew ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                      </span>
                      {errors.newPassword && (
                        <div className="invalid-feedback text-end">
                          {errors.newPassword}
                        </div>
                      )}
                    </div>

                    {/* =======================
                        ✅ تأكيد كلمة المرور الجديدة
                    ======================= */}
                    <div className="mb-4 position-relative">
                      <input
                        type={showConfirm ? "text" : "password"}
                        className={`form-control p-4 ${errors.confirmPassword ? "is-invalid" : ""
                          }`}
                        placeholder="تأكيد كلمة المرور الجديدة"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        onClick={toggleConfirm}
                        role="button"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "15px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                      >
                        {showConfirm ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                      </span>
                      {errors.confirmPassword && (
                        <div className="invalid-feedback text-end">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>

                    {/* =======================
                        زر الإرسال
                    ======================= */}
                    <div className="mb-4">
                      <button
                        type="submit"
                        className={`btn form-control py-3 ${isSubmitting ? "btn-secondary" : "btn-dark text-light"
                          }`}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "جارٍ التحديث..." : "تحديث كلمة المرور"}
                      </button>
                    </div>

                    {/*  رسائل الحالة */}
                    {formError && (
                      <div className="text-danger text-center mt-3 fw-bold">
                        {formError}
                      </div>
                    )}
                    {successMessage && (
                      <div className="text-success text-center mt-3 fw-bold">
                        {successMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
